import type { NavRoutesConfig } from "#app/_ui/components/headers/nav-routes-config";

import filterHelper from "./filterHelper";
import type { NavRoutesConfigFilterParams } from "./filterNav";

export default function heldawayFilter({
  navRoutesConfig,
  requiredData,
}: NavRoutesConfigFilterParams): NavRoutesConfig {
  if (!requiredData.heldawayUserEligibility) {
    const filtering = filterHelper(navRoutesConfig);
    return filtering
      .removeRouteById("ThreeSixtyWealthAndPlanning")
      .getFilteredRoutesConfig();
  }
  if (
    requiredData.heldawayUserEligibility &&
    !requiredData.heldawayUserEnrolled
  ) {
    const filtering = filterHelper(navRoutesConfig);
    return filtering
      .removeRouteSubById(
        "ThreeSixtyWealthAndPlanning",
        "ThreeSixtyWealthAccounts",
      )
      .removeRouteSubById(
        "ThreeSixtyWealthAndPlanning",
        "ThreeSixtyWealthTransactions",
      )
      .removeRouteSubById(
        "ThreeSixtyWealthAndPlanning",
        "ThreeSixtyWealthSpending",
      )
      .removeRouteSubById(
        "ThreeSixtyWealthAndPlanning",
        "ThreeSixtyWealthInvestments",
      )
      .removeRouteSubById(
        "ThreeSixtyWealthAndPlanning",
        "ThreeSixtyWealthSettings",
      )
      .getFilteredRoutesConfig();
  }
  return navRoutesConfig;
}
